import React from "react";
import Button from "./Button";
import { HiOutlineDownload } from "react-icons/hi";

const DownloadAgreement = ({ disabled = false, className = "" }) => {
  return (
    <div
      className={`flex flex-col bg-background_2/80 w-full md:w-1/2 gap-4 p-4 rounded-xl ${className}`}
    >
      <h2
        className={`text-headline5 font-nunito font-semibold ${
          disabled ? "text-secondary/60" : "text-secondary/90"
        }`}
      >
        Download your Agreement
      </h2>
      <div className="pl-2">
        <ul className="list-disc list-inside space-y-2">
          <li
            className={`text-caption font-ptsans font-normal ${
              disabled ? "text-secondary/35" : "text-secondary/60"
            }`}
          >
            Go through the agreement thoroughly before proceeding.
          </li>
          <li
            className={`text-caption font-ptsans font-normal ${
              disabled ? "text-secondary/35" : "text-secondary/60"
            }`}
          >
            Familiarize yourself with the rules and obligations outlined.
          </li>
        </ul>
      </div>
      <div className="w-1/2">
        <Button
          size="sm"
          variant="default"
          disabled={disabled}
          icon={HiOutlineDownload}
          onClick={() => {
            window.location.href =
              "https://api.indiancouriercompany.com/samples/Seller_Agreement.pdf";
          }}
          className={`flex items-center justify-center gap-2 ${
            disabled
              ? "bg-secondary/20 cursor-not-allowed"
              : "bg-primary text-white hover:bg-primary-dark"
          }`}
        >
          {"Download"}
        </Button>
      </div>
    </div>
  );
};

export default DownloadAgreement;
